import {Box, SvgIcon} from "@mui/material";
import React from "react";

export default function BowIcon(props) {
  return(
      <img src="/Icons/bow.svg" alt="bow" {...props}/>
  )

}